"use client"

import { Avatar } from "@heroui/react";

interface UserProfileAvatarProps {
  firstName?: string;
  lastName?: string;
  size?: "sm" | "md" | "lg";
  className?: string;
  isBordered?: boolean;
  alt?: string;
}

export function UserProfileAvatar({
  firstName,
  lastName,
  size = "md",
  className = "",
  isBordered = false,
  alt
}: UserProfileAvatarProps) {
  const safeFirstName = firstName?.trim() ?? "";
  const safeLastName = lastName?.trim() ?? "";
  const displayName = `${safeFirstName} ${safeLastName}`.trim() || "User";
  const initials =
    `${safeFirstName.at(0) ?? ""}${safeLastName.at(0) ?? ""}`.toUpperCase() ||
    displayName.at(0)?.toUpperCase() ||
    "U";

  return (
    <Avatar
      name={displayName}
      alt={alt || displayName}
      size={size}
      className={className}
      color="primary"
      isBordered={isBordered}
      showFallback
      fallback={initials}
    />
  );
}
